import React from 'react';

export interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ icon, title, description, action, className = '' }, ref) => {
    const containerClasses = [
      'text-center py-16 max-w-lg mx-auto animate-fade-in',
      className,
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <div ref={ref} className={containerClasses}>
        {icon != null && (
          <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-brand/10 border border-brand/20 flex items-center justify-center text-brand">
            {icon}
          </div>
        )}
        <h3 className="text-base font-semibold text-content mb-2">{title}</h3>
        {description != null && (
          <p className="text-sm text-content-muted mb-6 leading-relaxed">
            {description}
          </p>
        )}
        {action != null && <div>{action}</div>}
      </div>
    );
  },
);

EmptyState.displayName = 'EmptyState';

export default EmptyState;
